import { matchPath, useLocation } from 'react-router-dom'
import { feedUrl, loginUrl, signupFormUrl } from '@/urls'
import { pathnameWithoutLocalePrefix } from '@/util/localePath'

const useCurrentRouteName = () => {
  const { pathname } = useLocation()
  const path = pathnameWithoutLocalePrefix(pathname)
  const routePaths = {
    Feed: matchPath({ path: feedUrl(), end: true }, path),
    'Category page': path.startsWith('/q/category'),
    'Search page': path.startsWith('/search'),
    'Tags page': path.startsWith('/q/tag'),
    'Market page': /^\/q\/\d+/.test(path),
    Login: matchPath({ path: loginUrl() }, pathname),
    Signup: matchPath({ path: signupFormUrl() }, pathname),
  }

  const currentPage = Object.keys(routePaths).find(routeName => routePaths[routeName])

  return currentPage || 'not-found'
}
export default useCurrentRouteName
